import React from 'react'

export default function IconsEmailAddOutline(props) {
    return (
        <svg {...props} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3333 11.3579V5.52458C18.3333 5.08255 18.1577 4.65863 17.8452 4.34607C17.5326 4.0335 17.1087 3.85791 16.6667 3.85791H3.33334C2.89131 3.85791 2.46739 4.0335 2.15483 4.34607C1.84227 4.65863 1.66667 5.08255 1.66667 5.52458V15.5246C1.66667 16.4412 2.41667 17.1912 3.33334 17.1912H10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.3333 6.35791L10.8583 11.1079C10.6011 11.2691 10.3036 11.3546 10 11.3546C9.69641 11.3546 9.39895 11.2691 9.14167 11.1079L1.66667 6.35791" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.8333 13.8579V18.8579" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.3333 16.3579H18.3333" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        
    )
}
